/* SABERA motion + hero slideshow + video gating. No dependencies. Load with defer. */
(function () {
  var reduce = matchMedia('(prefers-reduced-motion:reduce)').matches;
  var isMobile = function () { return innerWidth < 750; };

  function reveals(scope) {
    scope.querySelectorAll('[data-sb-stagger]').forEach(function (g) {
      Array.prototype.forEach.call(g.children, function (c, i) { c.style.setProperty('--i', i); });
    });
    var els = scope.querySelectorAll('[data-sb-reveal],[data-sb-stagger],[data-sb-line]');
    if (reduce) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: .08, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  function parallax(scope) {
    if (reduce || isMobile()) return;
    var layers = [].slice.call(scope.querySelectorAll('[data-sb-parallax]'));
    if (!layers.length) return;
    var queued = false;
    function tick() {
      queued = false;
      var vh = innerHeight;
      layers.forEach(function (w) {
        var r = w.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        var p = (r.top + r.height / 2 - vh / 2) / vh;
        var m = w.querySelector('img,video');
        if (m) m.style.transform = 'translate3d(0,' + (-p * 34).toFixed(1) + 'px,0)';
      });
    }
    function onScroll() { if (!queued) { queued = true; requestAnimationFrame(tick); } }
    addEventListener('scroll', onScroll, { passive: true });
    addEventListener('resize', onScroll, { passive: true });
    tick();
  }

  /* Videos: never download on mobile or with reduced motion. data-src holds the real source. */
  function videos(scope) {
    var vids = [].slice.call(scope.querySelectorAll('video[data-sb-video]'));
    vids.forEach(function (v) {
      var src = v.getAttribute('data-src');
      if (!src) return;
      if (isMobile() || reduce) return;              /* poster only */
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) {
            if (!v.src) { v.src = src; v.load(); }
            v.play().catch(function () {});
          } else { v.pause(); }
        });
      }, { threshold: .25 });
      io.observe(v);
    });
    scope.querySelectorAll('[data-sb-sound]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var v = document.getElementById(btn.getAttribute('data-sb-sound'));
        if (!v) return;
        v.muted = !v.muted;
        btn.setAttribute('aria-pressed', String(!v.muted));
        btn.textContent = v.muted ? 'SOUND ON' : 'SOUND OFF';
      });
    });
  }

  function rails(scope) {
    scope.querySelectorAll('[data-sb-rail]').forEach(function (rail) {
      if (rail.dataset.sbRailReady === 'true') return;
      rail.dataset.sbRailReady = 'true';
      function syncFocus() {
        var scrollable = rail.scrollWidth > rail.clientWidth + 1;
        if (scrollable) rail.setAttribute('tabindex', '0');
        else rail.removeAttribute('tabindex');
      }
      rail.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        var card = rail.querySelector(':scope > *');
        var gap = parseFloat(getComputedStyle(rail).gap) || 0;
        var distance = card ? card.getBoundingClientRect().width + gap : rail.clientWidth * .75;
        rail.scrollBy({ left: event.key === 'ArrowRight' ? distance : -distance, behavior: reduce ? 'auto' : 'smooth' });
      });
      syncFocus();
      if ('ResizeObserver' in window) new ResizeObserver(syncFocus).observe(rail);
      else addEventListener('resize', syncFocus, { passive: true });
    });
  }

  function slideshow(root) {
    var slides = [].slice.call(root.querySelectorAll('.sabera-hero__slide'));
    var dots = [].slice.call(root.querySelectorAll('.sabera-hero__dot'));
    if (slides.length < 2) {
      var onlyHeading = slides[0] && slides[0].querySelector('[data-sb-hero-heading]');
      if (onlyHeading && onlyHeading.tagName !== 'H1') {
        var onlyH1 = document.createElement('h1');
        [].slice.call(onlyHeading.attributes).forEach(function (attr) { onlyH1.setAttribute(attr.name, attr.value); });
        onlyH1.innerHTML = onlyHeading.innerHTML;
        onlyHeading.replaceWith(onlyH1);
      }
      return;
    }
    var i = 0, delay = parseInt(root.getAttribute('data-autoplay') || '6500', 10), timer = null;
    var status = root.querySelector('[data-sb-slide-status]');
    function paint() {
      slides.forEach(function (s, n) {
        var active = n === i;
        s.classList.toggle('is-active', active);
        s.setAttribute('aria-hidden', String(!active));
        var heading = s.querySelector('[data-sb-hero-heading]');
        var tag = active ? 'H1' : 'H2';
        if (heading && heading.tagName !== tag) {
          var replacement = document.createElement(tag);
          [].slice.call(heading.attributes).forEach(function (attr) { replacement.setAttribute(attr.name, attr.value); });
          replacement.innerHTML = heading.innerHTML;
          heading.replaceWith(replacement);
        }
      });
      dots.forEach(function (d, n) { d.setAttribute('aria-current', String(n === i)); });
      if (status) {
        var activeHeading = slides[i].querySelector('[data-sb-hero-heading]');
        status.textContent = 'Slide ' + (i + 1) + ' of ' + slides.length + ': ' + (activeHeading ? activeHeading.textContent.trim() : 'Featured collection');
      }
    }
    function go(n) { i = (n + slides.length) % slides.length; paint(); restart(); }
    function restart() { if (timer) clearInterval(timer); if (delay > 0 && !reduce) timer = setInterval(function () { go(i + 1); }, delay); }
    dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n); }); });
    var p = root.querySelector('[data-sb-prev]'), nx = root.querySelector('[data-sb-next]');
    if (p) p.addEventListener('click', function () { go(i - 1); });
    if (nx) nx.addEventListener('click', function () { go(i + 1); });
    var cue = root.querySelector('[data-sb-scroll]');
    if (cue) cue.addEventListener('click', function () {
      var section = root.closest('.shopify-section');
      var target = section && section.nextElementSibling;
      if (target) target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    });
    root.addEventListener('mouseenter', function () { if (timer) clearInterval(timer); });
    root.addEventListener('mouseleave', restart);
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(i + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(i - 1); }
    });
    var sx = null;
    root.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var d = e.changedTouches[0].clientX - sx;
      if (Math.abs(d) > 45) go(i + (d < 0 ? 1 : -1));
      sx = null;
    }, { passive: true });
    paint(); restart();
  }

  function productTabs(scope) {
    scope.querySelectorAll('[data-sabera-product-tabs]').forEach(function (root) {
      if (root.dataset.sbTabsReady === 'true') return;
      root.dataset.sbTabsReady = 'true';
      var tabs = [].slice.call(root.querySelectorAll('[role="tab"]'));
      function activate(tab, focus) {
        tabs.forEach(function (item) {
          var selected = item === tab;
          item.setAttribute('aria-selected', String(selected));
          item.tabIndex = selected ? 0 : -1;
          var panel = root.querySelector('#' + item.getAttribute('aria-controls'));
          if (panel) panel.hidden = !selected;
        });
        if (focus) tab.focus();
      }
      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () { activate(tab, false); });
        tab.addEventListener('keydown', function (event) {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          var next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
          activate(tabs[next], true);
        });
      });
    });
  }

  function personalization(scope) {
    scope.querySelectorAll('[data-sabera-personalization]').forEach(function (root) {
      if (root.dataset.sbPersonalizationReady === 'true') return;
      root.dataset.sbPersonalizationReady = 'true';
      var input = root.querySelector('[data-sabera-personalization-input]');
      var count = root.querySelector('[data-sabera-personalization-count]');
      var error = root.querySelector('[data-sabera-personalization-error]');
      var mainForm = document.querySelector('.m-product-form--main form');
      var purchaseRow = mainForm && mainForm.querySelector('.m-product-form--wrapper');
      if (!input || !mainForm || !purchaseRow) return;

      purchaseRow.parentNode.insertBefore(root, purchaseRow);
      input.setAttribute('form', mainForm.getAttribute('id'));
      document.querySelectorAll('.m-product-dynamic-checkout').forEach(function (button) { button.hidden = true; });
      input.addEventListener('input', function () {
        input.value = input.value.slice(0, 18);
        count.textContent = input.value.length;
        error.hidden = true;
      });

      document.querySelectorAll('product-form form').forEach(function (form) {
        form.dataset.sbPersonalizationForm = 'true';
        form.addEventListener('submit', async function (event) {
          var name = input.value.trim();
          if (!name) return;
          root.dataset.sbPersonalizationSubmitted = 'true';
          event.preventDefault();
          event.stopImmediatePropagation();
          error.hidden = true;

          var variantInput = form.querySelector('[name="id"]');
          var quantityInput = form.querySelector('[name="quantity"]') || mainForm.querySelector('[name="quantity"]');
          var quantity = Math.max(1, parseInt(quantityInput && quantityInput.value || '1', 10));
          var submitter = event.submitter || form.querySelector('[name="add"]');
          if (!variantInput || !variantInput.value) return;
          if (submitter) submitter.disabled = true;

          try {
            var sections = [];
            document.documentElement.dispatchEvent(new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sections } }));
            var addUrl = window.MinimogSettings.routes.cart_add_url;
            if (!/\.js(?:\?|$)/.test(addUrl)) addUrl = addUrl.replace(/\/$/, '') + '.js';
            var response = await fetch(addUrl, {
              method: 'POST',
              headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
              body: JSON.stringify({
                items: [
                  { id: variantInput.value, quantity: quantity, properties: { 'Name personalization': name } },
                  { id: root.dataset.feeVariantId, quantity: quantity, properties: { 'Name': name, '_Personalization for': root.dataset.productTitle } }
                ],
                sections: sections,
                sections_url: window.location.pathname
              })
            });
            var result = await response.json();
            if (!response.ok || result.status) throw new Error(result.description || result.message || 'Unable to add personalization.');
            var cart = document.querySelector('m-cart-drawer');
            if (cart && window.MinimogSettings.enable_cart_drawer) cart.open();
            window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, { cart: result, productVariantId: variantInput.value });
            document.dispatchEvent(new CustomEvent('product-ajax:added', { detail: { product: result } }));
          } catch (exception) {
            error.textContent = exception.message;
            error.hidden = false;
          } finally {
            if (submitter) submitter.disabled = false;
          }
        }, true);
      });
    });
  }

  function init(scope) {
    scope = scope || document;
    reveals(scope); parallax(scope); videos(scope); rails(scope); productTabs(scope); personalization(scope);
    scope.querySelectorAll('[data-sb-slideshow]').forEach(slideshow);
  }
  document.readyState !== 'loading' ? init() : addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });  /* theme editor */
})();
